import styled from "styled-components";

export const Title = styled.h3`
  font-size: 21px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 6px;
  }
`;

export const SubTitle = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 16px;
  }
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
  display: block;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const SubLabel = styled.p`
  font-size: 16px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.5;
  padding-left: 1em;

  @media (max-width: 768px) {
    font-size: 14px;
    padding-left: 0.5em;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: var(--primary, #3b82f6);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &.error-field {
    border-color: #ef4444;
  }

  &:disabled {
    background-color: #f3f4f6;
    cursor: not-allowed;
  }
`;

export const InputContainer = styled.div`
  margin-bottom: 20px;
`;

export const OtpWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;

  input {
    width: 40px !important;
    height: 40px;
    margin: 0 5px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    border: 2px solid #d1d5db;
    border-radius: 8px;
    transition: all 0.2s;

    &:focus {
      outline: none;
      border-color: var(--primary, #3b82f6);
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }
`;

export const ButtonRecovery = styled.button`
  background: none;
  border: none;
  color: var(--primary, #3b82f6);
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  padding: 8px 0;
  margin-top: 12px;

  &:hover {
    opacity: 0.8;
  }
`;

export const LinkContainer = styled.div`
  text-align: center;
  margin-top: 16px;

  a {
    color: var(--primary, #3b82f6);
    text-decoration: none;
    font-size: 14px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const QRContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  background-color: #f7f7f7;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 12px;
    gap: 16px;
  }

  ${SubLabel} {
    @media (max-width: 768px) {
      width: 100% !important;
      text-align: center;
      padding-left: 0;
    }
  }
`;

export const QRImageContainer = styled.div`
  width: 200px;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 160px;
  }
  
  img {
    width: 180px;
    height: 180px;
    border: 1px solid #c4c4c4;

    @media (max-width: 768px) {
      width: 130px;
      height: 130px;
    }
  }

  p {
    text-align: center;
    margin-bottom: 0;
    font-size: 16px;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

export const BackupCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: #f7f7f7;
  padding: 24px;
  margin: 16px auto;
`;

export const BackupCodeText = styled.p`
  margin: 8px 0;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  margin: 0 8px;
  color: var(--primary, #3b82f6);
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
